export default __webpack_public_path__ + "static/media/VideoIcon.41e83f7d.svg";